export default __webpack_public_path__ + "static/media/img_sell_now_banner.7396bbc2.png";